import EmailRoundedIcon from "@mui/icons-material/EmailRounded";
import VerifiedIcon from "@mui/icons-material/Verified";
import SmsRoundedIcon from "@mui/icons-material/SmsRounded";
import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";
import SettingsIcon from "@mui/icons-material/Settings";
import WysiwygIcon from "@mui/icons-material/Wysiwyg";
import GoogleIcon from "@mui/icons-material/Google";
import WebhookIcon from "@mui/icons-material/Webhook";
import NewspaperIcon from "@mui/icons-material/Newspaper";
import { Business } from "@mui/icons-material";
import CopyAllOutlinedIcon from "@mui/icons-material/CopyAllOutlined";
import ModeEditIcon from "@mui/icons-material/ModeEdit";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import VisibilityIcon from "@mui/icons-material/Visibility";
import CampaignIcon from "@mui/icons-material/Campaign";
import HideSourceIcon from "@mui/icons-material/HideSource";
import AdsClickIcon from "@mui/icons-material/AdsClick";
import CachedIcon from '@mui/icons-material/Cached';
import AssessmentOutlinedIcon from "@mui/icons-material/AssessmentOutlined";

export const baseIconStyle = {
  fontSize: 24,
};

export const iconConfig = {
  click: {
    component: AdsClickIcon,
  },

  refresh: {
    component: CachedIcon,
  },

  plus: {
    component: AddIcon,
  },

  whatsapp_api: {
    component: VerifiedIcon,
  },

  email: {
    component: EmailRoundedIcon,
  },

  hide: {
    component: HideSourceIcon,
  },

  sms: {
    component: SmsRoundedIcon,
  },

  delete: {
    component: DeleteIcon,
  },

  settings: {
    component: SettingsIcon,
  },

  "Google planilhas": {
    component: GoogleIcon,
  },

  file: {
    component: WysiwygIcon,
  },

  API: {
    component: WebhookIcon,
  },

  Excel: {
    component: NewspaperIcon,
  },

  ERP: {
    component: Business,
  },

  duplicate: {
    component: CopyAllOutlinedIcon,
  },
  edit: {
    component: ModeEditIcon,
  },
  "view-off": {
    component: VisibilityOffIcon,
  },

  view: {
    component: VisibilityIcon,
  },

  analyze: {
    component: AssessmentOutlinedIcon,
  },

  campaign: {
    component: CampaignIcon,
  },
};
